import VVSTable from "components/form-control/VVSTable";
import { template } from "constants/dataTempleteExcel";
import React from "react";
import { Container } from "reactstrap";

export default function Question() {
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <VVSTable
            title="Câu hỏi"
            name="Question"
            showImportExcel
            disableAdd
            showSynchronizedData
            template={template.question}
            showConfigAnswer
            whereQuery={{
              category: {
                $ne: "nBHAwgRxHL",
              },
            }}
          />
        </Container>
      </div>
    </React.Fragment>
  );
}
